// extracted by mini-css-extract-plugin
export var adjacentSlide = "_q8-9";
export var arrowButtonContainer = "_q8-5";
export var arrowButtonIcon = "_q8-6";
export var carouselArrowButton = "_q8-2";
export var carouselElementContainer = "_q8-1";
export var currentSlide = "_q8-8";
export var left = "_q8-3";
export var otherSlide = "_q8-a";
export var productCarouselContainer = "_q8-0";
export var right = "_q8-4";
export var sliderOverflow = "_q8-7";